<template>
    <MainContent
        title="Listado de zonas"
        :disabled="loading"
    >
        <!-- 1. Título con botón de atrás: chrome de MainContent (PageTitleComponent). -->

        <!-- 2+3. Card: subtítulo + buscador + tabla -->
        <Card v-if="!error" :padding="0" customClasses="tw:mb-4">
            <div class="tw:px-6 tw:py-5 tw:border-b tw:border-slate-200">
                <h2 class="tw:text-base tw:font-bold tw:text-slate-900 tw:tracking-tight">
                    Listado para descargar en formato de pegatina las butacas vendidas en las zonas
                </h2>
                <p class="tw:text-xs tw:text-slate-500 tw:mt-1 tw:mb-0">
                    Generación de etiquetas adhesivas térmicas para butacas asignadas por sector y fila.
                </p>
            </div>

            <div class="tw:px-6 tw:py-4 tw:border-b tw:border-slate-100 tw:bg-slate-50/50">
                <div class="tw:w-full tw:max-w-md">
                    <SearchComponent
                        :value="filters.search"
                        placeholder="Buscar"
                        @input="value => (filters.search = value)"
                    />
                </div>
            </div>

            <BaseTable
                data-cy="zonas-table"
                naked
                :columns="columns"
                :data="zonas.data || []"
                :skeleton="loading"
                :skeleton-rows="5"
                empty-text="No hay zonas para esta sesión"
                default-col-width="auto"
            >
                <template #skeleton-opciones>
                    <div class="tw:h-9 tw:w-32 tw:bg-gray-200 tw:rounded tw:mx-auto"></div>
                </template>

                <template #cell-name="{ row }">
                    <span class="tw:block tw:truncate tw:uppercase tw:tracking-wide tw:font-semibold" :title="row.name">{{ row.name }}</span>
                </template>

                <template #cell-opciones="{ row, index }">
                    <OptionsDropdownComponent
                        :force-open-down="index === 0"
                        :options="[
                            { type: 'url', url: imprimirUrl(row), label: 'Imprimir pegatinas', icon: 'print' },
                        ]"
                    />
                </template>
            </BaseTable>
        </Card>

        <Card v-else customClasses="tw:mb-4">
            <p class="tw:text-red-600 tw:text-sm tw:m-0">{{ error }}</p>
        </Card>

        <!-- 4. TableFooter: paginador y elementos por página -->
        <TableFooter
            :value="filters"
            :meta="loading ? {} : meta"
            @input="value => Object.assign(filters, value)"
        />
    </MainContent>
</template>

<script setup>
    import MainContent from '@/modules/admin/ui/MainContent.vue';
    import Card from '@/modules/admin/ui/Card.vue';
    import SearchComponent from '@/modules/admin/ui/SearchComponent.vue';
    import BaseTable from '@/modules/admin/ui/table/BaseTable.vue';
    import TableFooter from '@/modules/admin/ui/table/TableFooter.vue';
    import OptionsDropdownComponent from '@/modules/admin/ui/OptionsDropdownComponent.vue';

    import { useZonasPegatinas } from '@/composables/admin/events/sesiones/useZonasPegatinas';

    const props = defineProps({
        evento_id: {
            type: [Number, String],
            required: true,
        },
        sesion_id: {
            type: [Number, String],
            required: true,
        },
    });

    const {
        zonas,
        loading,
        error,
        filters,
        meta,
        columns,
        imprimirUrl,
    } = useZonasPegatinas({
        eventoId: props.evento_id,
        sesionId: props.sesion_id,
    });
</script>
